// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.box[data-v-5ca43291]{background-color:#f6f6f6;padding-bottom:50px;width:100%}#terms[data-v-5ca43291]{max-width:1170px;min-height:60vh;width:100%;margin:0 auto;padding-bottom:150px;word-break:break-all;overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
